import React from 'react';
import PropTypes from 'prop-types';

export default class RecruitHeroes extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object
    };
    render() {
        const {
            title, description, subtitle, title1, title2
        } = this.props.content;
        return (
            <div className="recruit-heroes container-fluid">
                <div className="heroes" />
                <div className="content">
                    <h2>{subtitle}</h2>
                    <h1>{title1 && title2 ? <>{title1}<br></br>{title2}</> : title}</h1>
                    <div dangerouslySetInnerHTML={{__html: description}} />
                </div>
            </div>
        );
    }
}

